import { render, staticRenderFns } from "./internal-note-card.vue?vue&type=template&id=be76db50&"
import script from "./internal-note-card.vue?vue&type=script&lang=js&"
export * from "./internal-note-card.vue?vue&type=script&lang=js&"
import style0 from "./internal-note-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports